module.exports = __webpack_public_path__ + "static/img/leads-count-yellow.9cfc17f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leads-count-yellow.svg
// module id = 460
// module chunks = 0